import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Инициализация аутентификации БЕЗ повторного вызова
import { useAuthStore } from './stores/auth'

const initApp = async () => {
  // Монтируем приложение сразу
  app.mount('#app')

  // Аутентификация инициализируется автоматически в auth store
  const authStore = useAuthStore()

  // Дополнительная проверка токена (опционально)
  if (localStorage.getItem('auth_token') && !authStore.user) {
    try {
      console.log('Attempting to restore user session...')
      // initializeAuth уже вызывается в store, но можно принудительно
    } catch (error) {
      console.error('Failed to restore session:', error)
      // Очищаем некорректный токен
      localStorage.removeItem('auth_token')
    }
  }
}

// Запускаем инициализацию
initApp()

// Регистрируем stores для разработки
if (import.meta.env.DEV) {
  window.__pinia = pinia
}
